import QrService from "../service/QrService";

export const QrInOut = (postData) => async (dispatch) => {
    dispatch({ type: "ASSIGN_OT_REQUEST" });
    try {
      const response = await QrService.post(`Post`, postData);
      dispatch({ type: "ASSIGN_OT_SUCCESS", payload: response.data });
    } catch (error) {
      dispatch({ type: "ASSIGN_OT_FAILURE", error: error.message });
    }
  };
  
